class Parametro {
    constructor(
        {
            id = null, 
            //mes_referencia = null, 
            //ano_referencia = null, 
            data_abertura_publico = null, 
            data_fechamento_publico = null, 
            //data_inicio_geracao_arquivo = null,
            //data_fim_geracao_arquivo = null, 
            //data_inicio_carga_familia = null, 
            //data_fim_carga_familia = null,
            usuario_inclusao = null, 
            data_registro_inclusao = null, 
            usuario_alteracao = null, 
            data_registro_alteracao = null, 
            usuario_inativacao = null, 
            data_registro_inativacao = null,
            ind_ativo = null             
        } = {}
    ) {
        this.id = id; 
        //this.mes_referencia = mes_referencia, 
        //this.ano_referencia = ano_referencia, 
        this.data_abertura_publico = data_abertura_publico, 
        this.data_fechamento_publico = data_fechamento_publico, 
        //this.data_inicio_geracao_arquivo = data_inicio_geracao_arquivo,
        //this.data_fim_geracao_arquivo = data_fim_geracao_arquivo, 
        //this.data_inicio_carga_familia = data_inicio_carga_familia, 
        //this.data_fim_carga_familia = data_fim_carga_familia,
        this.usuario_inclusao = usuario_inclusao, 
        this.data_registro_inclusao = data_registro_inclusao, 
        this.usuario_alteracao = usuario_alteracao, 
        this.data_registro_alteracao = data_registro_alteracao, 
        this.usuario_inativacao = usuario_inativacao, 
        this.data_registro_inativacao = data_registro_inativacao,
        this.ind_ativo = ind_ativo
    }
}

export default Parametro;